import clsx from 'clsx';
import React, { type MouseEventHandler } from 'react';

import FlexLink from '@components/FlexLink';
import { subscriber_profile_path } from '@routes';
import { User } from '@utils/backend-api/currentUser';

export default function UserProfileLink({
  children,
  className,
  linkClassName,
  onClickCapture,
  user,
}: {
  children: React.ReactNode;
  className?: string;
  linkClassName?: string;
  onClickCapture?: MouseEventHandler<HTMLAnchorElement>;
  user: Pick<User, 'name' | 'username' | 'profile_enabled'>;
}) {
  // TODO: Should link be disabled if user doesn't have an active/paying account?

  if (user.profile_enabled) {
    return (
      <FlexLink
        href={subscriber_profile_path(user.username)}
        className={clsx(className, linkClassName)}
        onClickCapture={onClickCapture}
        toRailsPage
      >
        {children}
      </FlexLink>
    );
  }

  return <span className={className}>{children}</span>;
}
